// extracted by mini-css-extract-plugin
export default {"emptyStubKpiContainer":"EmptyStubKpi_emptyStubKpiContainer__yfrEI"};